<template lang="pug">
div
  FlowEditor(:flow-aliases="aliases", show-not-passed)
</template>

<script>
import FlowEditor from "@/components/FlowEditor";

export default {
  name: "candidate_editor",

  components: {
    FlowEditor,
  },

  data: () => ({
    aliases: ["candidate"],
  }),
};
</script>